import React, { ReactElement } from 'react';
import AntLayout from 'antd/es/layout';
import { Button, Space, theme } from 'antd';
import styles from './footer.module.css';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

export interface AudienceFooterProps {
  children?: ReactElement | null;
  isDisabled?: boolean;
  isLoading?: boolean;
  handleSubmit?: () => void;
  className?: string;
  additionalActions?: ReactElement | null;
}

const { Footer: AntFooter } = AntLayout;

export function AudienceFooter({
  isDisabled,
  isLoading,
  children,
  handleSubmit,
  className,
  additionalActions,
}: AudienceFooterProps) {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  return (
    <AntFooter
      className={cx(styles.footer, className)}
      style={{
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        backgroundColor: token.colorBgContainer,
      }}
    >
      <Space className={children ? styles.space : undefined}>
        {children}
        <div className={styles.controls}>
          {additionalActions}
          <Button
            type="primary"
            disabled={isDisabled}
            loading={isLoading}
            onClick={handleSubmit}
            data-testid="audienceSubmitButton"
          >
            {t('general_submit')}
          </Button>
        </div>
      </Space>
    </AntFooter>
  );
}
